import React, { ReactNode } from 'react';

interface AuthTabPageHeaderProps {
  title: string;
  description: string | ReactNode;
}

const AuthSettingsItemHeader = ({ title, description }: AuthTabPageHeaderProps) => {
  return (
    <div className='pb-8'>
      <div className='text-blue-primary pb-2.5 text-xl font-bold'>{title}</div>
      <div className='border-gray-tertiary text-blue-primary border-b pb-8'>{description}</div>
    </div>
  );
};

export default AuthSettingsItemHeader;
